import { ApiHelper } from './apiHelper';

export class PolicyApi {
    getPolicyDetails(
        vrn,
        dateOfFirstRegistration,
        brandId,
        emailAddress,
        token,
        successCallback = null,
        failureCallback = null
    ) {
        var query = encodeURI(
            `?vrn=${vrn}&dateOfFirstRegistration=${dateOfFirstRegistration}&brandId=${brandId}&emailAddress=${emailAddress}`
        );
        var dataUrl = '/api/policy/getpolicydetails' + query;
        new ApiHelper().getDataSecure(
            dataUrl,
            token,
            successCallback,
            failureCallback
        );
    }
}
